import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

import {
  Payments,
  Payment,
  Gateway,
  OnlinePayment,
  OnlinePaymentList,
  UserPaymentEmailList,
  UserPaymentEmail
} from '../models/payments.model';

import { environment } from 'src/environments/environment';

const baseUrl: string = environment.baseUrl;
const baseUrlV2: string = environment.baseUrlTwo;

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(
    private http: HttpClient
  ) { }

  getUserPayments(limit, offset, currency_id?, user_id?): Observable<Payments> {

    let params = new HttpParams();
    params = params.append('limit', limit);
    params = params.append('offset', offset);

    if (user_id) {
      params = params.append('user_id', user_id);
    }
    if (currency_id) {
      params = params.append('currency_id', currency_id);
    }

    return this.http.get<Payments>(`${baseUrlV2}/finance/payment/`, { params });
  }

  getUserPaymentDetail(paymentId: number): Observable<Payments> {
    return this.http.get<Payments>(`${baseUrl}/finance/payment/${paymentId}/`);
  }

  createUserPayment(data): Observable<Payment> {
    return this.http.post<Payment>(`${baseUrlV2}/finance/payment/`, data);
  }

  confirmUserPayment(id) {
    let data = {};
    return this.http.post(`${baseUrl}/finance/payment/${id}/confirm/`, data)
  }

  getOnlinePayments(filters): Observable<OnlinePaymentList> {
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    return this.http.get<OnlinePaymentList>(`${baseUrlV2}/finance/online-payment/`, { params });
  }

  getOnlinePaymentGateways(filters?: any): Observable<Gateway[]> {
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<Gateway[]>(`${baseUrlV2}/finance/gateways/`, {params});
  }

  createOnlinePayment(data): Observable<OnlinePayment> {
    return this.http.post<OnlinePayment>(`${baseUrlV2}/finance/online-payment/`, data);
  }

  validateOnlinePayment(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${baseUrlV2}/finance/online-payment/validation/`, { ...data }).subscribe(
        success => {
          data = {
            data: success
          }
          resolve('');
        },
        error => {
          data = error;
          reject();
        }
      )
    })

  }

  getCustomerCards(paymentMethodId: any, filters: any): Observable<any> {
    let params = new HttpParams();

    for (const filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    return this.http.get<any>(`${baseUrl}/finance/customer-cards/${paymentMethodId}/`, { params });
  }

  getCustomerPanelLink(data: any): Observable<any> {
    let params = new HttpParams();

    // for (const filter in filters) {
    //   if (filters[filter]) {
    //     params = params.append(filter, filters[filter]);
    //   }
    // }

    return this.http.post<any>(`${baseUrl}/finance/panel-link/`,  data);
  }

  getAdminCustomerPanelLink(data): Observable<any> {
    return this.http.post(`${baseUrl}/finance/admin-customer-panel-link/`, data);
  }

  getUserPaymentEmails(): Observable<UserPaymentEmailList> {
    return this.http.get<UserPaymentEmailList>(`${baseUrl}/finance/user_payment_email/`);
  }

  createUserPaymentEmail(data): Observable<UserPaymentEmail> {
    return this.http.post<UserPaymentEmail>(`${baseUrl}/finance/user_payment_email/`, data);
  }

  checkHiGift(pin: { pin: string }): Observable<any> {
    return this.http.post<any>(`${baseUrlV2}/finance/check-gift-card/`, pin);
  }

  getPaymentCategoryList(): Observable<any> {
    return this.http.get<any>(`${baseUrl}/finance/gateways-by-category/`);
  }
}
